module.exports = __webpack_public_path__ + "static/img/li3_2.b70b5ca9.png";